var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "tableContainer", staticClass: "main-page f-2" },
    [
      _vm.adaptHeight
        ? _c("v-table", {
            staticClass: "table-style",
            staticStyle: { width: "100%" },
            attrs: {
              "is-horizontal-resize": "",
              "is-vertical-resize": "",
              "column-width-drag": "",
              height: _vm.adaptHeight,
              columns: _vm.columns,
              "table-data": _vm.tableData,
              "row-click-color": "#edf7ff",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }